import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'content',
    'tabsList',
    'tabsContentList',
    'tabsContentImage',
    'tabs',
    'tabsWrapper',
  ]

  connect() {
    this.setWrapperHeight()
    this.observer = new ResizeObserver(() => {
      // console.log('ResizeObserver callback is running!')
      this.setWrapperHeight()
    })
    this.observer.observe(this.tabsContentListTarget) // Still observing tabsContentListTarget for now
  }

  disconnect() {
    this.observer.disconnect()
  }

  setWrapperHeight() {
    // console.log('setWrapperHeight() is being called!')
    this.measureAccordionHeight() // Call measureAccordionHeight to update this._maxHeight
    const tabsWrapper = this.tabsWrapperTarget
    tabsWrapper.style.height = `${this._maxHeight}px` // Use this._maxHeight
  }

  measureAccordionHeight() {
    let accordionHeight = 0
    const tabsContentList = this.element.querySelector('#tabs-content-list')
    const tabsContentImage = this.element.querySelector('#tabs-content-image')
    const tabs = this.element.querySelector('#tabs')

    if (!tabsContentList || !tabsContentImage || !tabs) {
      return // Exit if elements are not found
    }

    const isMobile = window.innerWidth < 1024

    tabs.style.height = 'auto' // Reset height to auto for measurement
    accordionHeight = tabs.scrollHeight // Measure scrollHeight

    this._maxHeight = accordionHeight
  }
}
